export async function initMocks() {
  if (typeof window === 'undefined') {
    const { server } = await import('./server');
    server.listen({
      onUnhandledRequest: 'bypass',
    });
  } else {
    const { worker } = await import('./browser');
    // 워커가 뜨기 전 첫 요청(세션 조회 등)이 모킹되지 않고 실제 서버로 나가지 않도록 기다린다.
    await worker.start({
      onUnhandledRequest: 'bypass',
      serviceWorker: {
        // 상대 경로면 /verify/phone 같은 중첩 경로에서 /verify/mockServiceWorker.js를 찾아 404가 난다.
        url: '/mockServiceWorker.js',
      },
    });
  }
}
